import { render, staticRenderFns } from "./EipCollapse.vue?vue&type=template&id=477979aa&"
import script from "./EipCollapse.vue?vue&type=script&lang=js&"
export * from "./EipCollapse.vue?vue&type=script&lang=js&"
import style0 from "./EipCollapse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports